@switch (breakSvc.breakPointDevice()){
@default {
<div class="auth-mobile-page-container ps-h-100">
  <div class="ps-w-100 ps-d-flex ps-flex-wrap">
    <div class="authentication-title-container">
      <p purpleEditableText tranKey='register_page_title' class="auth-form-title">
        {{ T.REGISTER.page_title | translation: [] }}
      </p>
      <p purpleEditableText tranKey='register_page_subtitle' class="auth-form-subtitle">
        {{ T.REGISTER.page_subtitle | translation: [] }}
      </p>
    </div>

    @if(purpleFormFieldGroups!= undefined){
    <purple-form [disabledForm]="isLoading" class="ps-w-100" [(formGroup)]="validateForm"
      [purpleFormFieldGroups]="purpleFormFieldGroups">
    </purple-form>
    }
    <purple-policy-form [(formGroup)]="validateForm" policyPosition="register" [getPolicyType]="'byPosition'"
      [(policyAgreements)]="formPolicies"></purple-policy-form>
  </div>

  <div class="ps-w-100 ps-d-flex ps-flex-wrap ps-mt-auto">
    <div purpleEditableText tranKey='register_page_login_disclaim' class="login-disclaim" [innerHTML]="T.register_page_login_disclaim | translation: 
          [((tsvc.currentLanguage())??'')+'/login']"></div>


    <purple-simple-button [isLoading]="isLoading" [isDisabled]="isLoading" purpleEditableText
      [buttonText]="T.REGISTER.page_register_step_2_button | translation: []" cssClass="register-button"
      tranKey='register_page_register_step_2_button' (click)="register()" buttonType="primary">

    </purple-simple-button>
  </div>
</div>
}
@case ('desktop') {
<div class="desktop-page-external-container">
  <div class="desktop-page-container">
    <div class="ps-w-100 ps-d-flex ps-flex-wrap auth-container">
      <!-- <img contentId="logo-authentication-header" contentTypeId="logo" purpleEditableImage
            class="authentication-logo"> -->
      <div class="auth-container-form-container">
        <div class="auth-form-container auth-register-form-container">
          <p purpleEditableText tranKey='register_page_desktop_form_title' class="auth-form-title">
            {{ T.REGISTER.page_desktop_form_title | translation: [] }}
          </p>
          <p purpleEditableText tranKey='register_page_desktop_step_1_form_subtitle' class="auth-form-subtitle">
            {{ T.register_page_desktop_step_1_form_subtitle | translation}}
          </p>

          <nz-tabs (nzSelectedIndexChange)="onTabChange($event)" [(nzSelectedIndex)]="currentTab"
            class="ps-w-100 register-tabset">

            <nz-tab class="ps-w-100">
              @if (purpleFormFieldGroups != undefined) {
              <purple-form class="ps-w-100" [(formGroup)]="validateForm"
                [purpleFormFieldGroups]="purpleFormFieldGroups">
              </purple-form>
              }

            </nz-tab>
            <nz-tab class="ps-w-100">
              @if(purpleFormFieldGroups2 != undefined) {
              <purple-form class="ps-w-100" [(formGroup)]="validateForm"
                [purpleFormFieldGroups]="purpleFormFieldGroups2">
              </purple-form>
              }
              <purple-policy-form class="desktop-policy" [(formGroup)]="validateForm" policyPosition="register"
                [getPolicyType]="'byPosition'" [(policyAgreements)]="formPolicies"></purple-policy-form>
            </nz-tab>
          </nz-tabs>
          <div class="register-button-container">
            @if (currentTab == 1) {
              <div class="register-back-button">
            <purple-simple-button [isLoading]="isLoading" [isDisabled]="isLoading" iconType="ng-zorro" icon="arrow-left" (click)="back()" buttonType="default">
            </purple-simple-button>
              </div>

          }
            <purple-simple-button [isLoading]="isLoading" [isDisabled]="isLoading" [buttonText]="buttonText"
              cssClass="register-button" (click)="register()" buttonType="primary">
            </purple-simple-button>
          </div>



          <div purpleEditableText tranKey='register_page_login_disclaim' class="login-disclaim" [innerHTML]="T.register_page_login_disclaim | translation: 
                [((tsvc.currentLanguage())??'')+'/login']">
          </div>

        </div>
      </div>
       <div contentId="authentication-img" contentTypeId="auth-page" purpleEditableImage class="auth-container-img"> 
      <!-- <div class="auth-container-img"> -->
        <div class="black-overlay">
        </div>
        <div class="text-overlay">
          <div class="ps-w-100 ps-d-flex ps-flex-wrap ps-justify-content-center">
            <!-- <p purpleEditableText tranKey='auth_page_purple-fit_name' class="purple-fit-text">{{ T.AUTH_PAGE.purple_fit_name | translation: [] }}</p> -->
            <div class="purple-fit-text-logo" contentId="purple-fit-logo" contentTypeId="auth-page" purpleEditableImage>
            </div>
            <p purpleEditableText tranKey='auth_page_promo_disclaimer' class="purple-fit-promo-text">
              {{ T.AUTH_PAGE.promo_disclaimer | translation: [] }}
            </p>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
}
}